import { render, staticRenderFns } from "./RoomOrderCanteen.vue?vue&type=template&id=62ddc178"
import script from "./RoomOrderCanteen.vue?vue&type=script&lang=js"
export * from "./RoomOrderCanteen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports